
/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'
var jsonGraphics = null;
var eventDatabaseName = null;

expocadfx.DataManager = function() {
    //var eventDatabaseName = "19ces";
    eventDatabaseName = document.URL.substring(document.URL.toLocaleLowerCase().lastIndexOf('/events/') + 8, document.URL.lastIndexOf("/"));
    var data = expocadfx.fxData;
	var config = expocadfx.config;
    var txt = expocadfx.txt;
    var fxStyles = expocadfx.styles;
    var util = expocadfx.util;
	var comparer = expocadfx.comparer;
    var storeXml = expocadfx.storeXml;
    var ExhibitorList = expocadfx.ExhibitorList;
    var FxEvent = expocadfx.fxevent;
    var DataLoader = expocadfx.DataLoader;
    var DisplayExhibitor = expocadfx.DisplayExhibitor;
    var Exhibitor = expocadfx.Exhibitor;
	var overlays = expocadfx.overlays;
    var socialToolbar = expocadfx.SocialMedia;
    var elemById = expocadfx.element.elementById;
	
	var displayList = data.displayExhibitors;
    
    var doc = document;
    var loader =  new DataLoader();
    var loadCallback = null;
    var floorPlanCallback = null;
    var rmd = [];
    var i;
	
    var eventName = "";         // derived from shows.xml file
	var textReady = false;
	var salesTextReady = false;
	var pendingTextFile = "";
    var xmlExhibitorData = null;
    var jsonExhibitors = null;
    
	var xmlExhibitorShows = null;
	var nextDisplayExhibitorId = 1;
	var nextDisplayBoothId = 1;
	var waitingForExhbitorsShows = false;
	
        // random(?) number array for decrypt routine
    for( i = 0; i < 23; i++) {
        rmd[i] = config.contactEmail.charCodeAt(i) - 97;
    }
	
    config.contactEmail = "";
    
    //   initial load of text and configuration  ////////////
     function loadInitial( cb) {
        if( cb) {
            loadCallback = cb;
        }
        if( config.isXML){
            loader.load( "shows.xml", saveShows);
        }
        else{
            saveShowsSQL();
        }
        
    }
    
    function loadData( value, level, callback) {
        loader.load( value, callback);
    }
    
	function loadTextFile( fileName) {
        
        if( config.isXML){
            if( fileName === "") {
                loader.load( "textconfig.xml", textconfigDone);
                //textconfigDone(true);
            }
            else {
                loader.load( fileName, textconfigDone);
                //textconfigDone(true, results);
            }
            
            if( config.salesMode !== "none" ) {
                //if( prefix === "") {
                    loader.load( "fxsalestext.xml", saleTextDone);
                    //saleTextDone();
                //}
                //else {
                //loader.load( prefix + "_salestext.xml", saleTextDone);
                //}
            }
            else {
                salesTextReady = true;
            }
        }
        else{
            getTextConfigFromSQL();
        }      
        
	}
    
    function textconfigDone( success, results) {
		if( success) {
			txt.saveXMLText( results);
			textReady = true;
			if( salesTextReady) {
				doc.dispatchEvent( new FxEvent( "Text_Loaded", null));
			}
		}
		else {
			if( pendingTextFile !== "textconfig.xml") {
				pendingTextFile = "textconfig.xml";			//  OR step throuth array trying all ?
				loader.load( "textconfig.xml", textconfigDone);
			}
			else {
           //     alert( "Missing text file!");
                swal("", "Missing text file!", "error");
				return;
			}
		}
    }

    function jsonTextconfigDone( textSuccess, configSuccess) {
		if( textSuccess && configSuccess) {
            txt.saveJSONText ( textSuccess[0]);
            setConfig(configSuccess[0]);
            textReady = true;
            if (config.salesMode !== "none"){
                config.is3d = false;
            }
            doc.dispatchEvent( new FxEvent( "Text_Loaded", null));
			// if( salesTextReady) {
			// 	doc.dispatchEvent( new FxEvent( "Text_Loaded", null));
			// }

		}
    }
	
	function saleTextDone( success, results) {
		if( success) {
			salesTextReady = true;
            if( config.isXML){
                txt.saveXMLSalesText( results);
            }
            else{
                txt.saveJSONSalesText(success, results);
            }
            
			if( textReady) {
				doc.dispatchEvent( new FxEvent( "Text_Loaded", null));
			}
		}
		else {
			loader.load( "fxsalestext.xml", saleTextDone);
		}
	}
    
    function saveShows( success, results) {
        var i = 0;
        var tmp = results.getElementsByTagName( "show");
        var len = tmp.length;
		var name = "";
			// config.salesMode set by query string, not config_ ... .xml
        if( (config.salesMode === "sales" || config.salesMode === "exhibitor") && config.isXML) {
			loader.requestWithScript( "fxsales.ini", saveSalesIni);
        }
        
        for( i = 0; i < len; i++) {
			name = tmp[i].getAttribute("file").split(".")[0];
            data.arViews[i] = {
                name : name,
                label : tmp[i].getAttribute("tooltip"),
                source : name + "_cr.jpg"
            };
        }
            // determine event/view to load
        if( data.queryEvent !== "" && data.arViews.length > 1) {
            eventName = data.queryEvent;
        }
        else {
            if( len === 1) {
                eventName = data.arViews[0].name;
            }
            else if( len > 1) {
                eventName = "shows";
            }
        }
        
        var fName = "config_" + eventName + ".xml";
        loader.load( fName, configDone);
    }

    function saveShowsSQL( success, results) {
			// config.salesMode set by query string, not config_ ... .xml
        if( config.salesMode === "sales" || config.salesMode === "exhibitor" || config.salesMode === "contra") {
			//loader.requestWithScript( "fxsales.ini", saveSalesIni);
        }

        configDone();

    }
    
    function saveSalesIni( success, results) {
        var tmp = "";
        
        if( success) {
            tmp = results.getElementsByTagName( "user")[0];
            if( tmp && tmp.textContent !== "") {
                data.salesIniUser = tmp.textContent;
            }
            tmp = results.getElementsByTagName( "pswd")[0];
            if( tmp && tmp.textContent !== "") {
                data.salesIniPswd = tmp.textContent;
            }
            tmp = results.getElementsByTagName( "url")[0];
            if( tmp && tmp.textContent !== "") {
                data.salesUrl = tmp.textContent;
            }
            else {
                config.salesMode = "none";
          //      alert( "No url provided for Sales Mode");
                swal("", "No url provided for Sales Mode", "error");
            }
            
            tmp = results.getElementsByTagName( "c")[0];
            if( tmp && tmp.textContent !== "") {
                data.salesAllowedCommands = tmp.textContent.split(",");
            }
            tmp = results.getElementsByTagName( "port")[0];
            if( tmp && tmp.textContent !== "") {
                data.salesPort = tmp.textContent;
            }
            tmp = results.getElementsByTagName( "holdmodedisplayinfo")[0];
            if( tmp && tmp.textContent !== "") {
                config.holdModeExhibitorName = util.isTrue( tmp.textContent);
            }
            tmp = results.getElementsByTagName( "rateplansort")[0];
            if( tmp && tmp.textContent !== "") {
                config.sortRatePlans = tmp.textContent;
            }
            tmp = results.getElementsByTagName( "inactivelimit")[0];
            if( tmp && tmp.textContent !== "") {
                data.salesIdleLimit = tmp.textContent;
            }
            tmp = results.getElementsByTagName( "combineadjacentonly")[0];
            if( tmp && tmp.textContent !== "") {
                config.combineAdjacentOnly = util.isTrue( tmp.textContent);
            }
            
        }
        else {
            config.salesMode = "none";
        //    alert( "Could not read data required for FX Sales");
            swal("", "Could not read data required for FX Sales", "error");
            console.log( "Failed to read fxsales.ini");
        }
    }
    
    function configDone( success, results) {
        if(config.isXML){        
            loader.load( ("options_" + eventName + ".xml"), optionsDone);
            if( eventName === "shows") {
                storeXml.multiConfig( config, results);
            }
            else {
                storeXml.config( config, results);
            }

            if (config.activationCode !== "" && data.queryActCode !== "") {

                if(decrypt(config.activationCode) === data.queryActCode) {

                //alert("Authorized to download CSV");

                loader.rptRequestWithScript("exhibitorList.ini", rptDone);

                }

            }
        }
        else{
            optionsDone(true);
        }
        
    }

    function rptDone( success, results) {
        if ( success) {
            download(results, "exhibitorList.csv");
        }
    }

    function download(data, filename, type) {
        var file = new Blob([data], {type: type});
        if (window.navigator.msSaveOrOpenBlob) // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
        else { // Others
        var a = document.createElement("a"),
                url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(function() {
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);  
        }, 0); 
    }
    }
    
    function optionsDone( success, results) {
        var cb;
        if( success && config.isXML) {
            storeXml.options( results, config, fxStyles);
        }
        
        cb = loadCallback;
        loadCallback = null;
        cb();
    }
    
    ////////////////   load remaining files  //////////////////////////////////////////
     function loadMultiViewList( callback) {
        if( callback !== null) {
            loadCallback = callback;
        }
        loader.load( "exhibitor_shows.xml", saveEventExhibitors);
        loader.load( "boothlist_shows.xml", saveBoothList);
        if( config.bSocialButtons) {
            loader.load( "social_shows.xml", saveSocial);
        }
    }
    
     function loadAllData( fpcallback) {
//		var tm = 0;
        var basefile = eventName + ".xml";
        floorPlanCallback = fpcallback;
        
        if (config.isXML){
            loader.load( basefile, saveBooths);

            if( config.hasMultipleViews) {
                loader.load( "exhibitor_shows.xml", saveEventExhibitors);
                loader.load( "boothlist_shows.xml", saveBoothList);
            }
            loader.load( "ex_" + basefile, saveExhibitors);

            loader.load( "tx_" + basefile, saveBuildingText);

            if( config.showLists) {
                if( config.bCategoryData) {
                    loader.load( "ct_" + basefile, saveCategories);
                }

                if( config.bPavilionData) {
                    loader.load( "pv_" + basefile, savePavilionData);
                }

                if( config.bSubShowData) {
                    loader.load( "ss_" + basefile, saveSubShowData);
                }

                if( config.bCountryData && !config.bHideCountryList) {
                    loader.load( "cn_" + basefile, saveCountryData);
                    
                }
            }

            if( config.bSocialButtons) {
                loader.load( "social_" + basefile, saveSocial);
            }
            
            if( config.bOverlay) {
                loader.load( "overlays_" + basefile, saveOverlays);
            }

            loader.load( "tl_" + basefile, saveTechLayers);        
            
            loader.load( "u_" + basefile, saveUpdate);
        }
        else{
            
            getEventFromSQL();

            getEventTextFromSQL();
        }
        
//        tm = Date.now() - data.startTime;
//		console.log( "  request other data at  " + tm);
		
		if( config.elvis) {
			loader.requestWithScript( "eli.ini", saveElvisInfo);
        }

    }
	
	function loadGoogleAccount( callback) {
		loader.load( "fxga.xml", callback);
	}
	
	function saveElvisInfo( success, results) {
		var xmlNodes = null;
		var i = 0;
		
		if( success) {
			xmlNodes = results.getElementsByTagName( "Message");
			if( xmlNodes.length > 0) {
				for( i = 0; i < xmlNodes.length; i++) {
					config.elvisMessages.push(  { numGroup: xmlNodes[i].getAttribute( "numIndex"),
											msg: xmlNodes[i].textContent
											});
				}
			}
			
			xmlNodes = results.getElementsByTagName( "Numbers");
			if( xmlNodes.length > 0) {
				for( i = 0; i < xmlNodes.length; i++) {
					config.elvisNumbers.push( xmlNodes[i].textContent);
				}
			}
		}
		else {
			config.elvis = false;
			console.log( "Failed to load ELI data file");
		}
	}
	
	function saveTechLayers( success, results) {
		if( success) {
			data.xmlTechLayers = results;
			doc.dispatchEvent( new FxEvent( "Technical_Layers_Loaded", null));
		}
		else {
			console.log( "Technical Layers FAILED");
		}
	}
    
    function saveBuildingText( success, results) {
        data.xmlBldgTxt = results.querySelectorAll("OT");
    }

    function saveBooths( success, results) {
        //getEventFromSQL();
        
        data.xmlGraphics = results;
        floorPlanCallback();
    }

    function getEventFromSQL() {
        console.log("getting floorplan coords...");
        
        var buildUrl = window.location.origin + "/" + eventDatabaseName + "/webdrawing?requestedWidth=17280";
        if(config.apiView){
            buildUrl += "&viewName=" + config.apiView;
        }
        
        if(config.optionsSet != "none"){ 
            buildUrl += "&options=" + config.optionsSet;
        }
        
        $.ajax({
            //url:"http://localhost:59125/17sampl/webdrawing/BoothShapes?includeDeleted=false&scaleToWidth=17280",
            //url:window.location.origin + "/" + eventDatabaseName + "/webdrawing?requestedWidth=17280",
            //url: window.location.origin + "/" + eventDatabaseName + "/webdrawing?requestedWidth=17280",
            url: buildUrl,
            method: 'GET',
            data: "",
                success: function (res, status, jqr) {
                    if (res.length > 0) {  

                        jsonGraphics = res[0];

                        if(jsonGraphics.technicalLayers || jsonGraphics.additionalGraphics) {
                            
                            if (jsonGraphics.technicalLayers) {
                               data.jsonTechLayers = jsonGraphics.technicalLayers; 
                            }
                            
                            if(jsonGraphics.additionalGraphics) {
                                data.jsonGraphics = jsonGraphics.additionalGraphics;
                            }
                            
                            doc.dispatchEvent( new FxEvent( "Technical_Layers_Loaded", null));
                        }

                        if(jsonGraphics.overlays){
                            
                            var ov = expocadfx.overlays();
                            ov.save( null, jsonGraphics.overlays);
                        }

                        //console.log("ajax sql coords success");

                        getListDataFromSQL();
                    } 
                    else {
                        alert("Server Unavailable");
                    }
                }
            });

        
    }

    function getListDataFromSQL() {
        console.log("getting floorplan exhibitors and lists...");
            
        var buildUrl = window.location.origin + "/" + eventDatabaseName + "/webdrawing/Lists?includeDeleted=false";
        if(config.apiView){
            buildUrl += "&viewName=" + config.apiView;
        }

        if(config.optionsSet != "none"){ 
            buildUrl += "&options=" + config.optionsSet;
        }

        $.ajax({
            //url:window.location.origin + "/" + eventDatabaseName + "/webdrawing/Lists?includeDeleted=false&viewName=TEST",
            url: buildUrl,
            method: 'POST',
            data: "",
            success: function (res, status, jqr) {
                if (res.length > 0) {  

                    parsedListSiS = res[0].showInShows;
                    parsedListCn = res[0].countries;
                    parsedListPv = res[0].pavilions;
                    parsedListCat = res[0].categories;

                    jsonExhibitors = res[0].exhibitors;

                    if  (parsedListCat.length > 0){

                        config.bCategoryData = true;
                        document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "cat", jsonObject: parsedListCat}));
                    }
                    else{config.bCategoryData = false;}
                    if (parsedListPv.length > 0){
                        config.bPavilionData = true;
                        document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "pav", jsonObject: parsedListPv}));
                    }
                    else{config.bPavilionData = false;}
                    if  (parsedListSiS.length > 0){
                        config.bSubShowData = true; // Test.. Config_XML has attributes that tell FX if there is data for SiS, Pav, Country, and cat
                        document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "sis", jsonObject: parsedListSiS}));
                    }
                    else{config.bSubShowData = false;}
                    if (parsedListCn.length > 0){

                        config.bCountryData = true;
                        document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "country", jsonObject: parsedListCn}));
                    }
                    else {config.bCountryData = false;}


                    console.log("ajax sql exhibs and lists success");

                    floorPlanCallback();
                } 
                else {
                    alert("Server Unavailable");
                }              


            }
        });
    }

    function getEventTextFromSQL(){
        
        var optionsSet = "";
        var viewTemp = "";

        if(config.apiView){
            viewTemp += "&viewName=" + config.apiView;
        }
        
        if(config.optionsSet != "none"){ //Change this out later to viewName? 
            optionsSet = "&options=" + config.optionsSet;
        }

        var buildUrl = window.location.origin + "/" + eventDatabaseName + "/webdrawing/bldgText?requestedWidth=17280" + viewTemp + optionsSet;
        
        $.ajax({
            url: buildUrl,
            method: 'GET',
            data: "",
            success: function (res, status, jqr) {
                if (res.length >= 0) { 
                    var buildingText = res;
                    data.jsonBldgTxt = buildingText;
                }
                
            }
        });
    }

    function getTextConfigFromSQL(){
        
        var optionsSet = "";

        util.parseQuerySting(config, data);

        if(config.optionsSet != "none"){
            optionsSet = "&options=" + config.optionsSet;
        }

        var token = getCookieValue("token");
        
        if ( token != ""){
            token = "Bearer " + token;
        }
        
        $.ajax({
            url:window.location.origin + "/" + eventDatabaseName + "/webdrawing/Text?requestedWidth=17280" + optionsSet,
            method: 'GET',
            data: "",
            success: function (configRes, status, jqr) {
                if (configRes.length > 0) { 
                    $.ajax({
                        headers: {'Authorization' : token},
                        url:window.location.origin + "/" + eventDatabaseName + "/webdrawing/Config?requestedWidth=17280" + optionsSet,
                        method: 'GET',
                        data: "",
                        success: function (textRes, status, jqr) {
                            if (textRes.length > 0) { 
                                
                                jsonTextconfigDone(configRes,textRes);
                                
                            }                            
                        }
                        
                    });
                    
                }

                
            }
            
        });



    
    }

    function saveExhibitors( success, results) {     // from ex_<view name>.xml
        
        xmlExhibitorData = results;
    }

    function parseExhibitorSQL(){
        var exh = null;
        //var exhibitors = JSON.parse(localStorage.JSONExhibs);
        var exhibitors = jsonExhibitors;
        var numExhibitors = exhibitors.length;
        var i = 0;
		var dc = config.bDataEncrypted ? decrypt : null;
        
        for( i = 0; i < numExhibitors; i++) {	// for each exhibitor and available booth in this view
            exh = new Exhibitor( i, null, dc, exhibitors[i]);
			
			if( config.rentMode) {
				exh.name = getBoothLabel( data.booths[ exh.boothIndex]);
			}
			
            data.exhibitors.push( exh);
        }
		
		if( !config.hasMultipleViews) {
			doc.dispatchEvent( new FxEvent( "Ready_To_Validate_Favorites", null));  // expofx 330
		}
        
        jsonExhibitors = null;
        
        doc.dispatchEvent( new FxEvent( "View_Exhibitor_Data_Ready", null));  // pageControl 1083
    }
	
	function parseExhibitorData() {
        var exh = null;
        var exhibitors = xmlExhibitorData.getElementsByTagName("E");
        
        var numExhibitors = exhibitors.length;
        var i = 0;
		var dc = config.bDataEncrypted ? decrypt : null;
        
        for( i = 0; i < numExhibitors; i++) {	// for each exhibitor and available booth in this view
             exh = new Exhibitor( i, exhibitors[i], dc);
            //exh = new Exhibitor( i, null, dc, exhibitors[i]);
			
			if( config.rentMode) {
				exh.name = getBoothLabel( data.booths[ exh.boothIndex]);
			}
			
            data.exhibitors.push( exh);
        }
		
		if( !config.hasMultipleViews) {
			doc.dispatchEvent( new FxEvent( "Ready_To_Validate_Favorites", null));  // expofx 330
		}
		
        doc.dispatchEvent( new FxEvent( "View_Exhibitor_Data_Ready", null));  // pageControl 1083
	}
    
    function saveUpdate( success, results) {
        var xml = results.getElementsByTagName("U")[0];
        if( xml ) {
            data.updateNumber = parseInt(xml.getAttribute("u"), 10);
            data.lastMessageNumber = parseInt(xml.getAttribute("h"), 10);

            doc.dispatchEvent( new FxEvent("Last_Message_Number_Ready", null)); // expofx 165
        }
    }
    
    function savePavilionData( success, results) {
        if( success) {
            document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "pav", xml: results}));
        }
    }

    function saveSubShowData( success, results) {
        if( success) {
            document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "sis", xml: results}));
        }
    }
    
    function saveCountryData( success, results) {
        if( success) {
            document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "country", xml: results}));
        }
    }

    function saveCategories( success, results) {
        if( success) {
            document.dispatchEvent( new FxEvent( "Tree_Data_Ready", {type: "cat", xml: results}));
        }
    }
	
    function updateDisplayObjects() {
        var exh = null;
        var numExhibitors = data.exhibitors.length;
        var i = 0;
        var k = 0;
        var found = false;
        var display = data.displayExhibitors;
        var displayLength = 0;
        var displayObj = null;
		var obj = null;
		
		if( xmlExhibitorShows) {
			parseShowExhibitors();	// all exhibitors from multi-view event
		}
		
        for( i = 0; i < numExhibitors; i++) {       // for each exhibitor in this view
            found = false;
            exh = data.exhibitors[i];
            displayLength = display.length;
				//  object for 'Booth List'
			displayObj = new DisplayExhibitor( exh, config.viewName, data.displayBooths.length);
			
			displayObj.favorite = checkFavorite( exh.boothNumber, exh.exhId);
			
			if( data.booths[ exh.boothIndex].status === "0") {
				displayObj.name = getBoothLabel( data.booths[ exh.boothIndex]);
			}
			data.displayBooths.push( displayObj);
			
                // add to or update displayExhibitors[]
            if( !displayObj.bAvailable) {
                if( config.rentMode) {
					obj = JSON.parse(JSON.stringify( displayObj));		// clone object
					obj.id = displayLength;
					obj.name = getBoothLabel( data.booths[ exh.boothIndex]);
					
					display.push( obj);
					found = true;
				}
				else {
                    for( k = 0; k < displayLength; k++) {
                        if( display[k].bLocal && display[k].name === exh.name) {
							display[k].arBoothNumbers.push( exh.boothNumber);
							// if mv index is there, if single view, add index !
							if( !config.hasMultipleViews) {
								display[k].arBoothIndexes.push( exh.boothIndex);
							}
							
							display[k].location = display[k].arBoothNumbers.join( " ");
							
                            display[k].exhibIndex = i;		//  is this always true ??
                            display[k].exhId = exh.exhId;
								// if any booth with this exhibitor if Fav
							if( checkFavorite( exh.boothNumber, exh.exhId)) {
								display[k].favorite = true;
							}
                            found = true;
                            break;
                        }
                    }
                }
				
				if( !found) {
						// copy object made for 'Booth List' and put in 'Exhibitor List'
					displayObj = JSON.parse(JSON.stringify( displayObj));
					obj = util.arrayFind( data.premiumCompanies, "name", displayObj.name);
					if( obj) {
						displayObj.priority = obj.priority;
					}
					displayObj.id = displayLength;
					displayObj.favorite = checkFavorite( exh.boothNumber, exh.exhId);
					display.push( displayObj);
				
				}
            }
        }
		
        if(  data.grid === null) {
            addExhibitorGrid();
        }
		else {
			data.grid.refresh();
		}
        data.xmlExhibitors = null;
		nextDisplayBoothId = data.displayBooths.length;
		nextDisplayExhibitorId = data.displayExhibitors.length;
    }
    
	function checkFavorite( boothNumber, exhibitorId) {
		var i = 0;
		var favs = data.favoriteBooths;
		var len = favs.length;
		
		for( i = 0; i < len; i++) {
			if( favs[i].bth === boothNumber && favs[i].exh === exhibitorId) {
				return true;
			}
		}
		return false;
	}
    
	function saveEventExhibitors( success, results) {
		xmlExhibitorShows = results;
		if( waitingForExhbitorsShows) {
			parseShowExhibitors();
		}
	}
	
    function parseShowExhibitors() {        //  from exhibitors_shows
        var i = 0;
        var exh = null;
        var len = 0;
        var tmpName = "";
        var xml = null;
		var obj = null;
        
		if( xmlExhibitorShows) {
			xml = xmlExhibitorShows.getElementsByTagName( "e");
		}
		else {
			waitingForExhbitorsShows = true;
			return;
		}
			
        len = xml.length;
        
        for( i = 0; i < len; i++) {
            tmpName = xml[i].getAttribute("l");
            if( config.bDataEncrypted) {
                tmpName = decrypt( tmpName);
            }
            
            exh = new DisplayExhibitor( null);
            
            exh.id = i;
            exh.name = tmpName.trim();
            exh.viewName = xml[i].getAttribute( "f");
            exh.location = util.arrayFind( data.arViews, "name", exh.viewName).label;
            exh.boothIndex = String( xml[i].getAttribute( "d"));
            exh.arBoothIndexes = String( exh.boothIndex).split(",");  // legacy
            exh.exhibIndex = -1;
            exh.favorite = false;
            exh.priority = 0;
            exh.bLocal = ( exh.viewName === config.viewName);
            exh.bAvailable = false;
            
			obj = util.arrayFind( data.premiumCompanies, "name", exh.name);
			if( obj) {
				exh.priority = obj.priority;
			}
			
			exh.favorite = isShowExhibitorFavorite( exh.name, exh.viewName);
			
            data.displayExhibitors.push( exh);
        }
		if( !config.hasFloorPlan) {
			addExhibitorGrid();
		}
    }
	
	function isShowExhibitorFavorite( exhibitorName, viewName) {
		var bths = data.eventBooths;
		var numBooths = bths.length;
		var i = 0;
		
		for( i = 0; i < numBooths; i++) {
			if( bths[i].name === exhibitorName && bths[i].viewName === viewName) {
				if( checkFavorite( bths[i].boothNumber, bths[i].exhId)) {
					return true;
				}
			}
		}
		return false;
	}
	
    function saveBoothList( success, results) {
        var i = 0;
        var exh = null;
        var xml = null;
        var len = 0;
        var tmpName = "";
        
        xml = results.getElementsByTagName("e");
        len = xml.length;
		
        for (i = 0; i < len; i++) {
            tmpName = xml[i].getAttribute("l");
            
            if( config.bDataEncrypted) {
                tmpName = decrypt( tmpName);
            }
            
            exh = {
                name : tmpName,
                exhId : xml[i].getAttribute("i"),
                boothNumber : xml[i].getAttribute("b"),
                viewTitle : xml[i].getAttribute("h"),
                viewName : xml[i].getAttribute("f")
            };
            data.eventBooths.push( exh);
        }
			//  triggers favorites.validate
		doc.dispatchEvent( new FxEvent( "Ready_To_Validate_Favorites", null));
    }
    
    function saveSocial( success, results) {
        if( success && results !== null) {
            socialToolbar( results, elemById( "mainHeader"));
        }
    }
    
    function saveOverlays( success, results) {
		var ov;
		if( success) {
			ov = overlays();
			ov.save( results);
		}
    }
    
    function addExhibitorGrid() {
        var div = elemById( "exhGrid");
        if( div !== null && div !== undefined) {
            createExhibitorGrid();
        }
    }
    
     function checkForExhibitors() {      // from page ready
        if( data.status.exhibitorsReady) {
            createExhibitorGrid();
        }
    }
    
    function createExhibitorGrid() {
        data.grid = new ExhibitorList( data.displayExhibitors, data.booths, txt);
    }
    
    function decrypt( sInput) {
        var j = 0;
        var arr;
        var sOut = "";
        var charLen = 0;
        var i = 0;
        if( sInput && sInput !== "") {
            arr = sInput.split( ",");
            charLen = arr.length;
            for( i = 0; i < charLen; i += 1) {
                sOut += String.fromCharCode( arr[i]-rmd[j]);
                j++;
                if(j >= rmd.length) {
                    j = 0;
                }
            }
        }
        return sOut;
    }
    
    /////////////////////////   Dynamic update for FX sales  /////////////////////////
    function newExhibitor( bthNum, bthIndex) {
        var index = data.exhibitors.length;
        var exhObj = new Exhibitor( index, null, null);
        data.exhibitors.push( exhObj);
        exhObj.boothNumber = bthNum;
        exhObj.boothIndex = bthIndex;
        exhObj.exhibitorName = txt.AVAILABLE;
        return index;
    }
    
    function changeExhibitorNameField() {
		var display = data.displayBooths;
		var len = display.length;
		var i = 0;
		
		for( i = 0; i < len; i++) {
			if( display[i].bAvailable) {
				display[i].name = getBoothLabel( data.booths[ display[i].arBoothIndexes[0] ]);
			}
		}
    }
    
    function updateReleasedBooth( boothObj) {
        var i = 0;
        var idx = -1;
        var favObj = null;
        var display = data.displayExhibitors;
        var len = display.length;
        var exhObj = data.exhibitors[ boothObj.exhibitorIndex];
		var displayBooth = data.displayBooths[ boothObj.index];
        var displayObj = null;
		
        if( exhObj === null) {
            console.log( "exhObj is null for booth: " + boothObj.number);
        }
        else {
            var eName = exhObj.name;
			
            exhObj.name = getBoothLabel( boothObj);
            exhObj.exhId = "";

            exhObj.address1 = "";
            exhObj.address2 = "";
            exhObj.city = "";
            exhObj.state = "";
            exhObj.zip = "";
            exhObj.country = "";
            exhObj.contact = "";
            exhObj.phone = "";
            exhObj.fax = "";
            exhObj.email = "";
            exhObj.website = "";
            exhObj.profile = "";
            exhObj.category = "";
            exhObj.url = "";        // available booths can have a url ?
             
            for( i = 0; i < len; i++) {
                if( display[i].name === eName && display[i].bLocal ) {
                    
                    if( display[i].favorite) {
                        favObj = {
                            boothNumber : boothObj.number,
                            boothIndex : boothObj.index,
                            exhName : eName,
                            local : true,
                            fav : false
                        };
                        document.dispatchEvent( new FxEvent( "Exhibitor_Favorite_Change", favObj));
                    }
                    
                    if( display[i].arBoothIndexes.length === 1) {      // exhibitor only had one booth	
						
						displayObj = display[i];
						
						display.splice( i, 1);
						
                        displayObj.name = getBoothLabel( boothObj);
                        displayObj.exhId = "";
                        displayObj.exhibIndex = boothObj.exhibitorIndex;
                        displayObj.bAvailable = true;
						displayObj.id = nextDisplayBoothId;
						
						data.displayBooths.push( displayObj);
						nextDisplayBoothId += 1;
                    }
                    else {
                        idx = isInArray( boothObj.index, display[i].arBoothIndexes);
                        
                        if( idx !== -1) {
                            display[i].arBoothIndexes.splice( idx, 1);
                            display[i].boothIndex = display[i].arBoothIndexes.join( ",");    // legacy
                            display[i].arBoothNumbers.splice( idx, 1);
                            display[i].location = display[i].arBoothNumbers.join( " ");
                        }
						
						displayBooth = updateAvailableLabel( boothObj);
						displayBooth.bAvailable = true;
						displayBooth.exhId = "";
                    }
                    data.grid.refresh();
                    break;
                }
            }
        }
		doc.dispatchEvent( new FxEvent( "Booth_List_Change", null));
    }
    
    function updateTablesForRentHold( boothObj, exhibitorId, exhibitorName) {
        var i = 0;
        var found = false;
        var display = data.displayExhibitors;
        var displayLen = display.length;
        var exhObj = data.exhibitors[ boothObj.exhibitorIndex];  // assumed exactly 1 exh !!
		var displayObj = null;
		var label = "";
        
        if( (config.rentMode && boothObj.status === "2") || ( config.holdMode && boothObj.status === "1")) {
            exhObj.exhId = "";
            exhObj.name = config.rentMode ? txt.RENT_MODE_LABEL : txt.HOLD_MODE_LABEL;
        }
        else {
            exhObj.exhId = exhibitorId;
            exhObj.name = exhibitorName;
        }
        
		    //  find booth id displayBooths and update, booth has to exist
        for( i = 0; i < data.displayBooths.length; i++) {
            if( data.displayBooths[i].arBoothNumbers[0] === boothObj.number) {                
                label = getBoothLabel( boothObj);
                data.displayBooths[i].name = label || exhibitorName;
                data.displayBooths[i].exhId = exhibitorId;
                data.displayBooths[i].exhibIndex = boothObj.exhibitorIndex;
                data.displayBooths[i].favorite = false;
                data.displayBooths[i].bAvailable = false;
                                
            //				data.displayBooths[i].priority = ???
            }
        }            
			// Update or add to Exhibitor List
        for( i = 0; i < displayLen; i++) {
                // if this exhibitor is in display with local booth --> add this booth info
            if( display[i].bLocal && display[i].name === exhObj.name) {
                //  add booth number to existing exhibitor, then delete object for 'Available booth'
                if( isInArray( boothObj.index, display[i].arBoothIndexes) === -1) {
                    display[i].arBoothNumbers.push( boothObj.number);
                    display[i].arBoothIndexes.push( boothObj.index);
                    display[i].boothIndex = display[i].arBoothIndexes.join( ",");    // legacy
                    display[i].location = display[i].arBoothNumbers.join( " ");
                }
                found = true;
                break;
            }
        }
               
        if( !found) {       // No existing display object for exhibitor
            displayObj = new DisplayExhibitor( exhObj, config.viewName, nextDisplayExhibitorId);       
			
			display.push( displayObj);
			nextDisplayExhibitorId += 1;
		}
        data.grid.refresh();
		doc.dispatchEvent( new FxEvent( "Booth_List_Change", null));
    }

    function updateTablesForChildExhib( boothObj, exhibitorId, exhibitorName, isChild) {
        var i = 0;
        var found = false;
        var display = data.displayExhibitors;
        var displayLen = display.length;
        var exhObj = data.exhibitors[ boothObj.exhibitorIndex];  // assumed exactly 1 exh !!
		var displayObj = null;
		var label = "";
        
        if( (config.rentMode && boothObj.status === "2") || ( config.holdMode && boothObj.status === "1")) {
            exhObj.exhId = "";
            exhObj.name = config.rentMode ? txt.RENT_MODE_LABEL : txt.HOLD_MODE_LABEL;
        }
        else {
            // maybe skip this if we're adding a child exhibitor?
            exhObj.exhId = exhibitorId;
            exhObj.name = exhibitorName;
        }
        
        if(isChild){
            // Skip this step for child exhibitor or add the displayBooths object perhaps?
            data.displayBooths.push({
                arBoothIndexes: ["515"],
                arBoothNumbers: ["946"],
                bAvailable: false,
                bLocal: true,
                boothIndex: "515",
                boothNumber: "946",
                exhId: "T0000005",
                exhibIndex: data.exhibitors.length,
                favorite: false,
                id: data.displayBooths.length -1,
                location: "946",
                name: "Applied Computer Technology",
                priority: 0,
                viewName: "17sampl"

            });
        }
        else{
		    //  find booth id displayBooths and update, booth has to exist
            for( i = 0; i < data.displayBooths.length; i++) {
                if( data.displayBooths[i].arBoothNumbers[0] === boothObj.number) {
                    
                    var exhibitorIndex = boothObj.exhibitorIndex;

/*                     if(isChild){
                        data.displayBooths.push(data.displayBooths[i]);
                        i = data.displayBooths.length -1;
                        exhibitorIndex = data.exhibitors.length;  // This will fail at some point...
                        data.displayBooths[i].id = i;
                    } */
                    
                    label = getBoothLabel( boothObj);
                    data.displayBooths[i].name = label || exhibitorName;
                    data.displayBooths[i].exhId = exhibitorId;
                    data.displayBooths[i].exhibIndex = exhibitorIndex;
                    data.displayBooths[i].favorite = false;
                    data.displayBooths[i].bAvailable = false;
                                    
    //				data.displayBooths[i].priority = ???
                }
            }
            }
			// Update or add to Exhibitor List
        for( i = 0; i < displayLen; i++) {
                // if this exhibitor is in display with local booth --> add this booth info
            if( display[i].bLocal && display[i].name === exhObj.name) {
                //  add booth number to existing exhibitor, then delete object for 'Available booth'
                if( isInArray( boothObj.index, display[i].arBoothIndexes) === -1) {
                    display[i].arBoothNumbers.push( boothObj.number);
                    display[i].arBoothIndexes.push( boothObj.index);
                    display[i].boothIndex = display[i].arBoothIndexes.join( ",");    // legacy
                    display[i].location = display[i].arBoothNumbers.join( " ");
                }
                found = true;
                break;
            }
        }
               
        if( !found) {       // No existing display object for exhibitor
            if(isChild){
                exhObj = new Exhibitor(data.exhibitors.length, null);
                exhObj.exhId = exhibitorId;
                exhObj.name = exhibitorName;
                exhObj.boothIndex = boothObj.index;
                exhObj.boothNumber = boothObj.number;
                data.exhibitors.push(exhObj);
            }

            displayObj = new DisplayExhibitor( exhObj, config.viewName, nextDisplayExhibitorId, isChild);       
			
			display.push( displayObj);
			nextDisplayExhibitorId += 1;
		}
        data.grid.refresh();
		doc.dispatchEvent( new FxEvent( "Booth_List_Change", null));
    }
	
	function updateAvailableLabel( boothObj) {
		var displayBooth = util.arrayFind( data.displayBooths, "location", boothObj.number);
		if( displayBooth) {
			displayBooth.name = getBoothLabel( boothObj);
			doc.dispatchEvent( new FxEvent( "Booth_List_Change", {}));
		}
		return displayBooth;
	}
    
    function isInArray( value, arr) {
        var len = arr.length;
        var i;
        for( i = 0; i < len; i++) {
            if( value == arr[i]) {
                return i;
            }
        }
        return -1;
    }
    
    function addDisplayBooth( boothObj) {     // always Available booth
        var i = 0;
        var found = false;
        var displayObj = null;
        var displayLength = data.displayBooths.length;
        //  if booth status available && not in displayExhibitors
		
        if( boothObj.status !== "0") {
            return;
        }
        
        for( i = 0; i < displayLength; i++) {
            if( data.displayBooths[i].location === boothObj.number) {
                found = true;
                break;
            }
        }
        if( found) {
            return;
        }
        
        displayObj = new DisplayExhibitor( null, config.viewName, nextDisplayBoothId);
			
        displayObj.name = getBoothLabel( boothObj);

        displayObj.location = boothObj.number;
        displayObj.arBoothNumbers.push( boothObj.number);
		displayObj.boothNumber = boothObj.number;
		displayObj.arBoothIndexes.push( boothObj.index);
        displayObj.exhId = "";
        displayObj.boothIndex = displayObj.arBoothIndexes.join( ",");    // legacy
        displayObj.bAvailable = true;
		
        data.displayBooths.push( displayObj);
		
		nextDisplayBoothId += 1;
		
		doc.dispatchEvent( new FxEvent( "Booth_List_Change", {}));
    }
    
    function deleteDisplayBooth( bthNum) {
        var display = data.displayBooths;
        var displayLength = display.length;
        var i = 0;
        
        for( i = 0; i < displayLength; i++) {
            if( display[i].location === String( bthNum)) {
                display.splice( i, 1);
				doc.dispatchEvent( new FxEvent( "Booth_List_Change", {}));
                break;
            }
        }
    }
	
	function changeExhibiterName( boothObj, newName, exhId) {
		// find display object - for rented booth - with this booth number ( AND/OR exhibitor object ??)
		var i = 0;
		var newObj;
		var index = -1;
		var len = displayList.length;
		var displayObj = findDisplayObjectByNumber( boothObj.number, false);
		var arr = null;
		
		if( displayObj === null || displayObj.name === newName) {
			console.log( "No booth or exhibitor found for booth number: " + boothObj.number +
							"  new name: " + newName + "   exh Id: "  + exhId);
			return;
		}
			// change exhibitor object 
			//  check for child exhibitors, only change parent
		arr = String( boothObj.exhibitorIndex).split( ",");
		if( arr.length > 1) {
			for( i = 0; i < arr.length; i++) {
				if( data.exhibitors[ arr[i] ].exhId === exhId) {
					data.exhibitors[ arr[i] ].name = newName;
					break;
				}
			}
		}
		else {
			data.exhibitors[ boothObj.exhibitorIndex].name = newName;
		}
		
		for( i = 0; i < len; i++) {
			if( displayList[i].bLocal && !displayList[i].bAvailable && displayList[i].name === newName) {
				newObj = displayList[i];
			}
		}

		if( displayObj.arBoothNumbers.length === 1) {
			if( newObj) {
				newObj.arBoothIndexes.push( boothObj.index);
				newObj.arBoothNumbers.push( boothObj.number);
				newObj.arBoothNumbers.sort( comparer);
				newObj.location = newObj.arBoothNumbers.join( " ");
				index = displayList.indexOf( displayObj);		//  WILL indexOf MATCH OBJECTS ??
				displayList.splice( index, 1);
			}
			else {
				displayObj.name = newName;
			}
		}
		else {
			//  remove the booth number and index from display object
			for( i = 0; i < displayObj.arBoothNumbers.length; i++) {
				if( isInArray( boothObj.number, displayObj.arBoothNumbers) !== -1) {
					displayObj.arBoothIndexes.splice( i, 1);
					displayObj.arBoothNumbers.splice( i, 1);
					displayObj.location = displayObj.arBoothNumbers.join( " ");
					displayObj.boothIndex = displayObj.arBoothIndexes.join( ",");
					break;
				}
			}

			if( newObj) {
				newObj.arBoothIndexes.push( boothObj.index);
				newObj.arBoothNumbers.push( boothObj.number);
				newObj.arBoothNumbers.sort();
				newObj.location = newObj.arBoothNumbers.join( " ");
			}
			else {
					// create display obj for this booth with new name
				newObj = new DisplayExhibitor( null, config.viewName, nextDisplayExhibitorId);
				newObj.name = newName;

				newObj.location = boothObj.number;
				newObj.favorite = displayObj.favorite;
				newObj.arBoothNumbers.push( boothObj.number);
				newObj.exhId = data.exhibitors[ boothObj.exhibitorIndex].exhId;

				newObj.arBoothIndexes.push( boothObj.index);
				newObj.boothIndex = boothObj.index;
				data.displayExhibitors.push( newObj);
				
				nextDisplayExhibitorId += 1;
			}
		}
		data.grid.refresh();
	}
	
	function getBoothLabel( boothObject) {
		var label = "";
		
		if( boothObject.status === "0") {
			label = txt.AVAILABLE + " - ";
		}
		else if( config.rentMode) {
			label = txt.RENT_MODE_LABEL;
			return label;
		}
		
		if( label !== "") {
			label += ( config.units === "F") ? 
				boothObject.dimF + " - " + boothObject.areaF :
				boothObject.dimM + " - " + boothObject.areaM;
		}
		return label;
	}
	
	function findDisplayObjectByNumber( bthNum, available) {
		var len = displayList.length;
		var i = 0;
		for( i = 0; i < len; i++) {
			if( displayList[i].bLocal && displayList[i].bAvailable === available) {
				if( isInArray( bthNum, displayList[i].arBoothNumbers) !== -1) {
					return displayList[i];
				}
			}
		}
		return null;
    }
    
    function getCookieValue(a) {
        var b = document.cookie.match('(^|[^;]+)\\s*' + a + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    }
    
    return {
        addDisplayBooth: addDisplayBooth,
        addExhibitorGrid: addExhibitorGrid,
		changeExhibiterName: changeExhibiterName,
        changeExhibitorNameField: changeExhibitorNameField,
        checkForExhibitors: checkForExhibitors,
        deleteDisplayBooth: deleteDisplayBooth,
		getBoothLabel: getBoothLabel,
        getExhibitorObject: function( index) { return data.exhibitors[index];},
		loader: loader,
        loadAllData: loadAllData,
        loadData: loadData,
		loadGoogleAccount: loadGoogleAccount,
        loadInitial: loadInitial,
        loadMultiViewList: loadMultiViewList,
		loadTextFile: loadTextFile,
        newExhibitor: newExhibitor,
        parseExhibitorData: parseExhibitorData,
        parseExhibitorSQL: parseExhibitorSQL,
		parseShowExhibitors: parseShowExhibitors,
		updateAvailableLabel: updateAvailableLabel,
        updateDisplayObjects: updateDisplayObjects,
        updateTablesForRentHold: updateTablesForRentHold,
        updateTablesForChildExhib: updateTablesForChildExhib,
        updateReleasedBooth: updateReleasedBooth,
        zap : decrypt
    };
};